import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  DetailsFormControls,
  DetailsFormGroup,
  PersonalDataFormGroup,
} from '@app/models/form.models';
import { atLeastOneRequired } from '@app/ui-components/validated-checkbox-group/validated-checkbox-group.component';

export interface TermsAndConditionsFormGroup {
  privacyPolicy: FormControl<boolean>;
  termsAndConditions: FormControl<boolean>;
  passwordInfo: FormControl<boolean>;
  lawInfo: FormControl<boolean>;
}

export function getTemrsAndContitionsFormGroup(
  fb: FormBuilder,
  termAccepted: boolean
): FormGroup<TermsAndConditionsFormGroup> {
  return fb.nonNullable.group({
    privacyPolicy: fb.nonNullable.control<boolean>(
      termAccepted,
      Validators.requiredTrue
    ),
    termsAndConditions: fb.nonNullable.control<boolean>(
      termAccepted,
      Validators.requiredTrue
    ),
    passwordInfo: fb.nonNullable.control<boolean>(
      termAccepted,
      Validators.requiredTrue
    ),
    lawInfo: fb.nonNullable.control<boolean>(
      termAccepted,
      Validators.requiredTrue
    ),
  });
}

export function getPersonalDataFormGroup(
  fb: FormBuilder
): FormGroup<PersonalDataFormGroup> {
  return fb.nonNullable.group({
    title: fb.nonNullable.control<string>('', Validators.required),
    familyName: fb.nonNullable.control<string>('', Validators.required),
    middleName: fb.nonNullable.control<string>(''),
    givenName: fb.nonNullable.control<string>('', Validators.required),
    citizenship: fb.nonNullable.control<string>('', Validators.required),
    birthLastName: fb.nonNullable.control<string>('', Validators.required),
    birthMiddleName: fb.nonNullable.control<string>(''),
    birthFirstName: fb.nonNullable.control<string>('', Validators.required),
    birthPlace: fb.nonNullable.control<string>('', Validators.required),
    dateOfBirth: fb.nonNullable.control<string>('', Validators.required),
    motherLastName: fb.nonNullable.control<string>('', Validators.required),
    motherMiddleName: fb.nonNullable.control<string>(''),
    motherFirstName: fb.nonNullable.control<string>('', Validators.required),
    certificateType: fb.control<number | null>(null, Validators.required),
    numberOfCertificate: fb.nonNullable.control<string>(
      '',
      Validators.required
    ),
    expiryDate: fb.nonNullable.control<string>('', Validators.required),
    country: fb.nonNullable.control<string>('', Validators.required),
    postalCode: fb.nonNullable.control<string>('', Validators.required),
    city: fb.nonNullable.control<string>('', Validators.required),
    publicSpace: fb.nonNullable.control<string>('', Validators.required),
    publicSpaceType: fb.nonNullable.control<string>('', Validators.required),
    houseNumber: fb.nonNullable.control<string>('', Validators.required),
    doorOrFloor: fb.nonNullable.control<string>(''),
    optionalTaxNumber: fb.nonNullable.control<string>(''),
    optionalBankNumber: fb.nonNullable.control<string>(''),
  });
}

export function getDetailsFormGroup(fb: FormBuilder): DetailsFormGroup {
  const base = getPersonalDataFormGroup(fb);

  return new FormGroup<DetailsFormControls>({
    ...base.controls,
    roles: fb.nonNullable.control<string[]>([], {
      validators: [atLeastOneRequired],
    }),
    defaultLanguageCode: fb.nonNullable.control<string>(
      '',
      Validators.required
    ),
  });
}

export interface LegalPersonDataFormGroup {
  name: FormControl<string>;
  taxNumber: FormControl<string>;
  legalPersonCountry: FormControl<string>;
  legalPersonPostalCode: FormControl<string>;
  legalPersonCity: FormControl<string>;
  legalPersonPublicSpace: FormControl<string>;
  legalPersonPublicSpaceType: FormControl<string>;
  legalPersonHouseNumber: FormControl<string>;
  legalPersonDoorOrFloor: FormControl<string>;
  email: FormControl<string>;
  legalPersonOptionalBankNumber: FormControl<string>;
}

export function getLegaPersonData(
  fb: FormBuilder
): FormGroup<LegalPersonDataFormGroup> {
  return fb.nonNullable.group({
    name: fb.nonNullable.control<string>(''),
    taxNumber: fb.nonNullable.control<string>(''),
    legalPersonCountry: fb.nonNullable.control<string>(''),
    legalPersonPostalCode: fb.nonNullable.control<string>(''),
    legalPersonCity: fb.nonNullable.control<string>(''),
    legalPersonPublicSpace: fb.nonNullable.control<string>(''),
    legalPersonPublicSpaceType: fb.nonNullable.control<string>(''),
    legalPersonHouseNumber: fb.nonNullable.control<string>(''),
    legalPersonDoorOrFloor: fb.nonNullable.control<string>(''),
    email: fb.nonNullable.control<string>(''),
    legalPersonOptionalBankNumber: fb.nonNullable.control<string>(''),
  });
}

export interface ProofOfProfessionalStatusFormGroup {
  statusTitle: FormControl<string>;
  statusDescription: FormControl<string>;
}

export function getProofOfProfessionalStatusFormGroup(
  fb: FormBuilder
): FormGroup<ProofOfProfessionalStatusFormGroup> {
  return fb.nonNullable.group({
    statusTitle: fb.nonNullable.control<string>(''),
    statusDescription: fb.nonNullable.control<string>(''),
  });
}
